/**
 * The client's Activity Log. The editor is never named to a client.
 *
 * The server already sends a client only milestone events with nobody named in them
 * (backend app/client_identity.py). This is the second lock, for a payload that did not
 * come through that path: a route that returned the whole project (PUT /projects/{id} did,
 * until 2026-10-02) and was put straight into the drawer's state. On 2026-10-01 a client
 * read "Editor Assigned: Rom Dexter Manalo" in this log; the label text carried the name.
 *
 * For a client: only `system` and `upload_status` events, the name after "Editor
 * assigned / reassigned / unassigned / removed" cut off, and no actor fields at all, so
 * no "by {name}" can render. Every other role gets the history unchanged.
 */
export const CLIENT_ACTIVITY_TYPES = ['system', 'upload_status'];
const ACTOR_FIELDS = ['actor_name', 'actor_type', 'actor_id', 'changed_by',
  'old_editor_id', 'old_editor_name', 'new_editor_id', 'new_editor_name', 'editor_id', 'editor_name'];
const NAMED_LABEL = /^\s*(editor\s+(?:assigned|reassigned|unassigned|removed))\b[\s\S]*$/i;

export function clientLabel(label) {
  if (typeof label !== 'string') return label;
  const m = label.match(NAMED_LABEL);
  return m ? m[1].charAt(0).toUpperCase() + m[1].slice(1) : label;
}

export function activityFor(role, history) {
  const list = Array.isArray(history) ? history : [];
  if (role !== 'client') return list;
  return list
    .filter((ev) => ev && CLIENT_ACTIVITY_TYPES.includes(ev.status_type))
    .map((ev) => {
      const out = { ...ev };
      ACTOR_FIELDS.forEach((k) => { delete out[k]; });
      if ('label' in out) out.label = clientLabel(out.label);
      return out;
    });
}
